import styled from 'styled-components';



export const MissionVisionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  margin-top: 2rem;

  @media (min-width: 768px) {
    flex-direction: row;
    justify-content: space-between;
  }
`;

export const MissionVisionCard = styled.div`
  flex: 1;
  background: #ffffff;
  border: 1px solid ${(props) => props.theme.borderColor || '#e0e0e0'};
  border-radius: 8px;
  padding: 2rem;
  text-align: center;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.05);
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
  }

  h3 {
    font-size: 1.5rem;
    color: ${(props) => props.theme.primary};
    margin-bottom: 1rem;
    font-weight: bold;
  }

  p {
    font-size: 1rem;
    color: ${(props) => props.theme.text};
    line-height: 1.6;
    margin-bottom: 1rem;
  }
`;
